import { MapperBase } from '../../utilities/mapper-base';
import { DocAuditResource } from '../resource/doc-audit.resource';
import { AuditLog } from '../ui/audit-log.model';

export class DocAuditResourceToAuditLogMapper extends MapperBase<DocAuditResource, AuditLog> {
	map(source: DocAuditResource): AuditLog {
		const dest = new AuditLog();
		dest.case = source.case?.caseName;
		dest.dateAccessed = source.accessDateTime;
		dest.documentName = source.doc?.docTitle;
		dest.documentId = source.doc?.docId;
		dest.username = source.user?.userName;
		return dest;
	}

}

